namespace GeniuzPOS.Product {
    export interface CsConceptForm {
        ConceptCode: Serenity.StringEditor;
        ConceptName: Serenity.StringEditor;
    }

    export class CsConceptForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsConcept';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsConceptForm.init)  {
                CsConceptForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsConceptForm, [
                    'ConceptCode', w0,
                    'ConceptName', w0
                ]);
            }
        }
    }
}
